const quantitySelector = class extends HTMLElement {
  constructor () {
    super()
    this.initSelector()
  }

  initSelector () {
    const quantityButtons = this.querySelectorAll('[data-quantity-button]')
    const minButton = this.querySelector('[data-quantity-button][data-action="minus"]')
    const plusButton = this.querySelector('[data-quantity-button][data-action="plus"]')
    const quantityInput = this.querySelector('[data-quantity-input]')

    quantityButtons.forEach(quantityButton => {
      quantityButton.addEventListener('click', (event) => {
        const prevValue = quantityInput.value

        if (quantityButton.dataset.action === 'plus') {
          quantityInput.stepUp()
        } else if (quantityButton.dataset.action === 'minus') {
          quantityInput.stepDown()
        }

        if (prevValue !== quantityInput.value) {
          quantityInput.dispatchEvent(new Event('change'))
        }

        const isAtMax = quantityInput.value === quantityInput.max
        plusButton.disabled = isAtMax

        const isAtMin = quantityInput.value === quantityInput.min
        minButton.disabled = isAtMin
      })
    })
  }
}

if (typeof window.customElements.get('quantity-selector') === 'undefined') {
  window.customElements.define('quantity-selector', quantitySelector)
}
